import { render, staticRenderFns } from "./UResetPassSet.vue?vue&type=template&id=2f3c4800&scoped=true&"
import script from "./UResetPassSet.vue?vue&type=script&lang=ts&"
export * from "./UResetPassSet.vue?vue&type=script&lang=ts&"
import style0 from "./UResetPassSet.vue?vue&type=style&index=0&id=2f3c4800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c4800",
  null
  
)

export default component.exports